import logo1 from "../../assets/img/historicEvents/LogoOnlysPPV/FF4.png";

export const fatal4WayDetail = {
  "fatal-4-way": {
    id: "fatal-4-way",
    title: "Fatal 4-Way",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "fatal-4-way",
        items: [
          {
            id: "fatal-4-way-1",
            title: "Fatal 4-Way",
            description: "2010",
            imgUrl: logo1,
          },
        ],
      },
    ],
  },
};
